import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import CancelButton from 'hcla-web-frontend-primitives/app/components/primitives/Buttons/CancelButton';
import NewTrackableCard from 'hcla-web-frontend-primitives/app/components/primitives/Card/NewTrackableCard';
import CreateButton from 'hcla-web-frontend-primitives/app/components/primitives/Buttons/CreateButton';
import MultiUserSelectChip from 'hcla-web-frontend-primitives/app/components/primitives/Chips/MultiUserSelectChip';
import { injectIntl } from 'react-intl';
import AuthService from "hcla-web-frontend-primitives/app/Api/AuthService";
import Validators from "hcla-web-frontend-primitives/app/Utils/Validators";
import InputRules from "../Model/SingleHCLModelView/SingleTreeView/Inputs/InputRules";

const styles = theme => ({
  buttonWrapper: {
    justifyContent: 'space-between',
  },
  formControl: {
    padding: `${theme.spacing(2)}px 0px`,
    margin: `${theme.spacing(1)}px 0px`,
    zIndex: 1
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: `0 ${theme.spacing(2)}px`,
  },
  root: {
    width: 400,
  },
});

class NewHCLModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: {
        text: '',
        hasError: !Validators.isTitleValid('')
      },
      description: {
        text: '',
        hasError: !Validators.isDescriptionValid('')
      },
      assignedUsers: [AuthService.getProfile().user_id],
    };
  }

  handleChange = name => (event) => {
    const text = event.target.value;
    const hasError = () => {
      if (name === 'title') return !Validators.isTitleValid(text);
      if (name === 'description') return !Validators.isDescriptionValid(text);
    }
    this.setState({
      [name]: {
        text,
        hasError: hasError()
      },
    });
  };

  handleMultiChange = name => (event) => {
    this.setState({
      [name]: event,
    });
  };

  handleSubmit = () => {
    const {
      title, description, assignedUsers,
    } = this.state;
    const payload = {
      title: title.text,
      description: description.text,
      assigned_users: assignedUsers,
    };

    const { onSubmit } = this.props;
    onSubmit(payload);
  };

  render() {
    const {
      classes, cardHeader, intl, onCancel,
    } = this.props;
    const { description, title, assignedUsers } = this.state;
    return (
      <NewTrackableCard>
        {cardHeader}
        <CardContent className={classes.cardContent}>
          <TextField
            id="title"
            value={title.text}
            required
            onChange={this.handleChange('title')}
            fullWidth
            margin="normal"
            label={intl.formatMessage({ id: 'modelTitle' })}
            type="text"
            variant="outlined"
            error={!Validators.isEmpty(title.text) ? title.hasError : false}
            helperText={!Validators.isEmpty(title.text) && title.hasError ? Validators.ERROR_DESCRIPTIONS.TITLE : undefined}
          />
          <TextField
            id="description"
            value={description.text}
            onChange={this.handleChange('description')}
            multiline
            fullWidth
            rows="4"
            margin="normal"
            label={intl.formatMessage({ id: 'description' })}
            variant="outlined"
            error={description.hasError}
            helperText={description.hasError ? Validators.ERROR_DESCRIPTIONS.DESCRIPTION : undefined}
          />
          <FormControl className={classes.formControl}>
            <InputLabel shrink htmlFor="assigned-users">{intl.formatMessage({ id: 'mainContent.newModel.assignedUsers' })}</InputLabel>
            <MultiUserSelectChip
              selected={assignedUsers}
              handleUpdate={this.handleMultiChange('assignedUsers')}
              label={intl.formatMessage({ id: 'mainContent.newModel.assignedUsers' })}
              variant="outlined"
              inputProps={{
                id: 'assigned-users',
                ariaDescribedby: 'assigned-users-helper-text',
              }}
            />
            <FormHelperText id="assigned-users-helper-text">Leave blank to assign all users</FormHelperText>
          </FormControl>
        </CardContent>
        <CardActions className={classes.buttonWrapper}>
          <CancelButton
            variant="outlined"
            size="large"
            onClick={onCancel}
          >
            {intl.formatMessage({ id: 'cancel' })}
          </CancelButton>
          <CreateButton
            onClick={this.handleSubmit}
            variant="outlined"
            size="large"
            disabled={title.hasError || description.hasError}
          >
            {intl.formatMessage({ id: 'create' })}
          </CreateButton>
        </CardActions>
      </NewTrackableCard>
    );
  }
}

NewHCLModel.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  cardHeader: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.instanceOf(Function).isRequired,
  onCancel: PropTypes.instanceOf(Function).isRequired,
  intl: PropTypes.instanceOf(Object).isRequired,
};

export default injectIntl(withStyles(styles)(NewHCLModel));
